/** Counties of Ireland, used to route prayer requests and testimonies. */
export const IRISH_COUNTIES = [
    "Antrim",
    "Armagh",
    "Carlow",
    "Cavan",
    "Clare",
    "Cork",
    "Derry",
    "Donegal",
    "Down",
    "Dublin",
    "Fermanagh",
    "Galway",
    "Kerry",
    "Kildare",
    "Kilkenny",
    "Laois",
    "Leitrim",
    "Limerick",
    "Longford",
    "Louth",
    "Mayo",
    "Meath",
    "Monaghan",
    "Offaly",
    "Roscommon",
    "Sligo",
    "Tipperary",
    "Tyrone",
    "Waterford",
    "Westmeath",
    "Wexford",
    "Wicklow",
] as const

export type IrishCounty = (typeof IRISH_COUNTIES)[number]

const countySet = new Set<string>(IRISH_COUNTIES)

export function readOptionalCounty(
    value: unknown
): { ok: true; county: IrishCounty | null } | { ok: false } {
    if (value == null) return { ok: true, county: null }
    if (typeof value !== "string") return { ok: false }

    const trimmed = value.trim()
    if (!trimmed) return { ok: true, county: null }
    if (!countySet.has(trimmed)) return { ok: false }

    return { ok: true, county: trimmed as IrishCounty }
}
